import { inject, observer } from 'mobx-react';
import { CO2_Loading } from "../../Assets/CO2_Loading";
import { Colors, invertDark } from "../../Assets/Config/color.config";
import { CompanySelector } from "../Dashboard/companySelector";
import { CollapsibleTable } from "../../Tools/collapsibleTable";
import { Selector } from "../../Tools";
import React, { useEffect } from "react";
import { toJS } from 'mobx';

export const CertificateTable = inject("store")(observer((props) => {
    const theme = props.store.login.theme;

    const { certificatesV2 } = props;

    const { noCertificatesData, years, certificateYear, setCertificateYear, setSelectedCertificateId, _handleSelectYear, _handleFetchCompanyYears, setShowCertiTour } = props.store.dashboard;

    useEffect(() => {
        _handleFetchCompanyYears();
    }, [])

    console.log("certificates version 2 --->", toJS(certificatesV2))

    if (certificatesV2)
        return (
            <>

                <CollapsibleTable theme={theme} noCertificatesData={noCertificatesData} year={certificateYear} data={certificatesV2} setSelectedCertificateId={setSelectedCertificateId} setShowCertiTour={setShowCertiTour} />
            </>
        )
    else
        return <CO2_Loading />
}))


export default CertificateTable

{/* <div className="row text-center px-2 pb-3">
                    
                    {years.map(y => y.value).map((v) => (
                        <div className="col-2" key={v}>
                            <div
                                className="p-2"
                                style={{
                                    borderBottom: v === certificateYear ? `3px solid ${Colors.lightBlue}` : 'none',
                                    // background: v === certificateYear ? Colors.lightBlue : null,
                                    cursor: "pointer",
                                    fontWeight: v === certificateYear ? "bold" : "normal",
                                    color: invertDark(theme)
                                    //color: v === certificateYear ? Colors.Dark[4] : (theme === 'dark' ? Colors.Dark[5] : Colors.Dark[0]),
                                }}
                                onClick={(e) => {
                                    setCertificateYear(v)
                                }}
                            >
                                {v}
                            </div>
                        </div>
                    ))}
                </div> */}
